const Builder = require('../BuilderBase');
const HiddenFor = require('../HiddenFor');
const ShortText = require('./ShortText');
const Toggle = require('./Toggle');
const DropDown = require('./DropDown');
const DatePicker = require('./DatePicker');
const filters = require('../filters');

module.exports = class NestedObject extends Builder {
    constructor(title, properties) {
        super('formElement_NestedObject', title, properties);
        if (!properties.propertyName) {
            throw new Error(
                `${title} does not have a 'propertyName'.  You must pass a 'propertyName' value in properties when creating formElements.`
            );
        }
    }
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
    shortText(title, properties) {
        let shortText = new ShortText(title, properties);
        this.addChildBlock(shortText, 'NestedObjectElements');
        return shortText;
    }
    dropDown(title, properties) {
        let dropDown = new DropDown(title, properties);
        this.addChildBlock(dropDown, 'NestedObjectElements');
        return dropDown;
    }
    datePicker(title, properties) {
        let datePicker = new DatePicker(title, properties);
        this.addChildBlock(datePicker, 'NestedObjectElements');
        return datePicker;
    }
    toggle(title, properties) {
        let toggle = new Toggle(title, properties);
        this.addChildBlock(toggle, 'NestedObjectElements');
        return toggle;
    }

    filter(type, properties) {
        const Filter = filters[type];
        const filter = new Filter(properties);
        this.addChildBlock(filter, 'filters');
        return filter;
    }
};
